import styled from 'styled-components';

import { Col, Row } from '@components/formStyles';
import Button from '@components/Button';

export const Wrapper = styled.div`
  width: 100%;
  height: auto;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-right: 20px;
    margin-top: 24px;
  }
`;

export const SubtitleSeperator = styled.div`
  height: 24px;
  width: 1px;
  background: ${({ theme }) => theme.palette.grey300};
  margin: 0 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 0;
    height: 0;
    margin-bottom: 8px;
  }
`;

export const SpacingRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: -10px;
`;

export const InfoBorder = styled.div`
  height: 24px;
  width: 1px;
  margin: 0px 4px 0px 4px;
  background-color: ${({ theme }) => theme.palette.grey300};
`;

export const TitleContainer = styled.div`
  margin-top: -10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0;
  }
`;
export const Title = styled.span`
  font-size: 28px;
  font-weight: 700;
  line-height: 40px;
  color: ${({ theme }) => theme.palette.grey1100};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const DateStyle = styled.span`
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  margin-top: 2px;
  color: ${({ theme }) => theme.palette.grey800};
`;

export const Comment = styled.span`
  font-size: 16.2px;
  font-weight: 600;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
  }
`;

export const CommentNumber = styled.span`
  font-size: 13.5px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 10px;
  }
`;

export const Point = styled.div`
  width: 30px;
  height: 40px;
  background-color: ${(p) => p.theme.palette.validGreen};
  align-items: center;
  display: flex;
  justify-content: center;
  color: white;
  text-align: center;
  font-size: 16.2px;
  font-weight: 600;
  margin-left: 15px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
    width: 22px;
    height: 30px;
    margin: 0 0 0 5px;
  }
`;

export const RoutesInfoWrapper = styled.div`
  flex-direction: column;
  display: flex;
  margin-top: 24px;
`;

export const RoutesInfo = styled.span<{ isBold?: boolean }>`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 2px;
  color: ${({ theme }) => theme.palette.grey1100};
  ${({ isBold }) => isBold && `font-weight: 600`}
`;

export const RightCol = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 30%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 20px;
  }
`;

export const RightWrapper = styled(Col)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-left: 40px;
`;

export const CampaignLabelWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 136px;
  height: 47px;
  align-self: end;
`;

export const DiscountWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  font-size: 14px !important;
  height: 40px !important;
  font-weight: 600;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    height: 40px;
    font-size: 14px;
  }
`;

export const ReadMore = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.coral};
  cursor: pointer;

  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const PriceDetails = styled.span<{ isBold?: boolean }>`
  opacity: 0.75;
  font-size: 12px;
  text-align: right;
  color: ${({ theme }) => theme.palette.darkGrey};
  font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
`;

export const FlexEnd = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
`;

export const DynamicRow = styled(Row)`
  width: 100%;
  align-items: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
`;

export const IconText = styled.span<{ isDark?: boolean }>`
  font-size: 14px;
  margin-left: 4px;
  font-weight: 500;
  color: ${({ theme, isDark }) =>
    isDark ? theme.palette.grey1100 : theme.palette.grey800};
`;
export const TopWrapper = styled(DynamicRow)``;

export const BotWrapper = styled(DynamicRow)``;
